import { envConfig } from '../../../config/env';

export default {
  hero: {
    eyebrow: 'VR Lab · VR Laboratory',
    title: 'VR Laboratory at Jinan University',
    subtitle:
      'We focus on virtual reality, human-computer interaction, AI-powered smart education, and applied security—opening 2–3 collaboration Opening for outstanding students every year.',
    backgroundImage: `${envConfig.cdnBase}/backgroundImage.jpg`,
    primary: { text: 'Explore research', to: '/publications' },
    secondary: { text: 'Meet the team', to: '/members' },
  },
  intro: {
    paragraphs: [
      'Led by <strong>Professor Boyu Gao</strong>, the <strong>VR Laboratory of the School of Cyberspace Security at Jinan University</strong> works closely with the <strong>Guangdong Institute for Smart Education</strong>, advancing trustworthy multi-channel VR interaction across virtual reality, human-computer interaction, AI-enhanced education, and applied security.',
      'The group leads <span style="color: #2b5cd8; font-weight: bold;">more than 10</span> national and provincial grants, including General and Young Scientist programs of the National Natural Science Foundation of China, subprojects of the National Key R&amp;D Program, and the Guangdong Natural Science Foundation. We have published <span style="color: #2b5cd8; font-weight: bold;">over 30</span> papers at venues such as <span style="background-color: #f2f4f7; color: #1f2329; padding: 2px 6px; border-radius: 4px;">IEEE VR</span>, <span style="background-color: #f2f4f7; color: #1f2329; padding: 2px 6px; border-radius: 4px;">IEEE TVCG</span>, and <span style="background-color: #f2f4f7; color: #1f2329; padding: 2px 6px; border-radius: 4px;">IJHCS</span>, and we welcome self-driven graduate and undergraduate students to email us and join early.'
    ]
  },
  news: {
    heading: 'Latest News',
    items: [
      {
        "date": "2025-11-12",
        "title": "Congratulations to <strong>Professor Boyu Gao</strong> on serving as a Program Committee Member for <span class=\"home__news-badge\">IEEE VR 2026</span> and <span class=\"home__news-badge\">IEEE ISMAR 2025</span>, and as Poster Chair for <span class=\"home__news-badge\">ICXR 2025</span>!"
      },
      {
        "date": "2025-11-08",
        "title": "Congratulations to <strong>PhD student Lei Chen</strong> for his work on large model-based intelligent scoring being accepted by <span class=\"home__news-badge\">AAAI 2026</span>!"
      },
      {
        "date": "2025-10-28",
        "title": "Our collaborative research on touchpad-based interaction with <strong>Professor Tu</strong> from La Trobe University has been published online in <span class=\"home__news-badge\">IEEE TVCG</span>!"
      },
      {
        "date": "2025-07-24",
        "title": "Congratulations to the research group's <strong>Guanyu</strong>, <strong>Zijun</strong>, and <strong>Zibo</strong> for their 3 papers being accepted by <span class=\"home__news-badge\">IEEE ISMAR 2025</span>!"
      },
      {
        "date": "2025-07-24",
        "title": "Congratulations to <strong>Professor Tingjie Wan</strong> for her paper being accepted by <span class=\"home__news-badge\">IEEE ISMAR 2025</span>!"
      },
      {
        "date": "2025-01-17",
        "title": "Congratulations to <strong>PhD student Zijun</strong> on her first paper being accepted by <span class=\"home__news-badge\">CHI 2025</span>!"
      }
    ]
  },
  research: {
    heading: 'Latest Research',
    more: 'View more results',
  },
};
